(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["moneyhouse-complete-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moneyhouse-set')) {
 customElements.define('moneyhouse-set', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const top = this.querySelector('[data-mh-top]');
   const bottom = this.querySelector('[data-mh-bottom]');
   const button = this.querySelector('[data-mh-add]');
   const total = this.querySelector('[data-mh-total]');
   const error = this.querySelector('[data-mh-error]');
   const update = () => {
    button.disabled = !top.value || !bottom.value;
    if (top.value && bottom.value) {
     const cents = Number(top.selectedOptions[0].dataset.price) + Number(bottom.selectedOptions[0].dataset.price);
     total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:window.Shopify.currency.active }).format(cents / 100);
    }
   };
   top.addEventListener('change', update);
   bottom.addEventListener('change', update);
   button.addEventListener('click', async () => {
    if (!top.value || !bottom.value) return;
    button.disabled = true; button.textContent = button.dataset.loading; error.textContent = '';
    try {
     const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:Number(top.value),quantity:1},{id:Number(bottom.value),quantity:1}]})
     });
     const result = await response.json();
     if (!response.ok) throw new Error(result.description || error.dataset.message);
     window.location.assign(window.Shopify.routes.root + 'cart');
    } catch (failure) {
     error.textContent = failure.message || error.dataset.message;
     button.textContent = button.dataset.label; update();
    }
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
